"use client";

/**
 * Check if the user has prefers-reduced-motion enabled.
 */
const prefersReducedMotion = () => {
	return window?.matchMedia("(prefers-reduced-motion: reduce)")?.matches;
};

export default prefersReducedMotion;
